<script lang="ts">
    import {Button, Input, Label, Modal, Textarea} from "flowbite-svelte";
    import {storeReminder} from "$lib/calls/employee";
    import type {Employee} from "$lib/types/employee";
    import ModalHeader from "$lib/components/ui/ModalHeader.svelte";
    import ModalFooter from "$lib/components/ui/ModalFooter.svelte";

    export let employee: Employee;
    export let open: boolean = false;


    let reminder = {
        employeeUuid: employee.uuid,
        remindAt: new Date(),
        note: ''
    }

    function submitReminder() {
        storeReminder(employee.uuid, reminder).then((storedReminder) => {
            console.log(storedReminder)
            employee.reminders = [...employee.reminders, storedReminder]
            open = false
        })
    }
</script>

<Modal
        title="Reminder erstellen"
        bind:open={open}>
    <svelte:fragment slot="header">
        <ModalHeader title="Reminder erstellen"/>
    </svelte:fragment>
    <form on:submit={submitReminder}>
        <div class="grid grid-cols-5 w-full gap-4">
            <Label for="reminderText" class="flex justify-end items-center">
                Erinnerung
            </Label>
            <Textarea
                    required
                    bind:value={reminder.note}
                    id="reminderText"
                    name="reminderText"
                    class="col-span-4"
                    type="text"/>

            <Label for="reminderDate" class="flex justify-end items-center">
                Wecker
            </Label>
            <Input
                    required
                    bind:value={reminder.remindAt}
                    id="reminderDate"
                    name="reminderDate"
                    class="col-span-4"
                    type="datetime-local"/>
        </div>
    </form>
    <svelte:fragment slot="footer">
        <ModalFooter on:abort={() => open = false} on:next={submitReminder} nextText="Reminder anlegen"/>
    </svelte:fragment>
</Modal>